<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.manageFiling.abbreviatedFiling.summary.title') }}
    </v-card-title>
    <v-card-subtitle v-if="!isLocked">
      {{ $t('page.manageFiling.abbreviatedFiling.summary.description') }}
    </v-card-subtitle>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <dl class="d-grid grid-4060">
            <dt>
              {{ $t('page.manageFiling.abbreviatedFiling.summary.docketEntry.name') }}
            </dt>
            <dd>
              {{ docketEntryName }}
            </dd>
            <dt>
              {{ $t('page.manageFiling.abbreviatedFiling.summary.filedOnBehalfOf.name') }}
            </dt>
            <dd>
              {{ filedOnBehalfOfName }}
            </dd>
            <template v-if="!isNil(filingStatement)">
              <dt>
                {{ $t('page.manageFiling.abbreviatedFiling.summary.filingStatement') }}
              </dt>
              <dd>
                {{ filingStatement }}
              </dd>
            </template>
            <template v-if="!isNil(bean.docketEntryDocument.documentLinkID)">
              <dt>
                {{ $t('global.document') }}
              </dt>
              <dd>
                <a :href="viewDocumentURL" target="_blank">
                  {{ bean.docketEntryDocument.documentName }}
                </a>
              </dd>
            </template>
            <template v-if="!isNil(comments)">
              <dt>
                {{ $t('page.manageFiling.abbreviatedFiling.summary.comments') }}
              </dt>
              <dd>
                {{ comments }}
              </dd>
            </template>
          </dl>
        </v-col>
      </v-row>
      <v-row v-if="filingFeesTotal !== 0" no-gutters class="mt-4">
        <v-col cols="12">
          <section-separator :title="$t('page.manageFiling.abbreviatedFiling.section.fees')" class="mb-5"/>
          <dl class="d-grid grid-4060">
            <dt>{{ $t('page.manageFiling.summary.filingFeesTotal') }}</dt>
            <dd>
              <button type="button" class="link-button" @click="filingFeesPopupVisible = true;">
                {{ filingFeesTotal | formatCurrency }}
              </button>
            </dd>
            <dt>{{ $t('page.manageFiling.summary.filingFeesDue') }}</dt>
            <dd>{{ filingFeesDue | formatCurrency }}</dd>
            <template v-if="hasFeeWaiver">
              <dt>{{ $t('filing.feeWaiverRequest') }}</dt>
              <dd>{{ feeWaiver.displayName }}</dd>
            </template>
          </dl>

          <filing-fees-popup v-model="filingFeesPopupVisible" :docketEntryID="leadDocketEntry.resourceID"/>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end mt-10">
      <template v-if="!isLocked">
        <c-btn type="primary" @click="$emit('submitFiling')" class="px-3">
          {{ $t('page.manageFiling.sidebar.submitFiling') }}
        </c-btn>
        <c-btn type="secondary" @click="$emit('edit')">
          {{ $t('global.edit') }}
        </c-btn>
      </template>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import Filing from '@/application/filing';
import WorkflowStepMixin from '@/mixins/workflowStep';
import FilingFeesPopup from '@components/support/manageFiling/FilingFeesPopup';
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();

export default {
  components: { FilingFeesPopup },
  mixins: [ WorkflowStepMixin ],
  data () {
    return {
      feeWaiver: null,
      filingFeesPopupVisible: false
    };
  },
  computed: {
    viewDocumentURL () {
      return this.$cove.getAPI({
        name: 'api.dms.document',
        params: { documentLinkID: this.bean.docketEntryDocument.documentLinkID }
      });
    },
    leadDocketEntry () {
      return filingStore.filing.leadDocketEntry;
    },
    docketEntryName () {
      return this.leadDocketEntry.docketEntryExternalName;
    },
    filingStatement () {
      return this.bean.docketEntry.docketEntryNote;
    },
    comments () {
      return this.bean.filing.filingNote;
    },
    filedOnBehalfOfName () {
      let filedOnBehalfOf =_.get(filingStore, 'filing.filedOnBehalfOf[0]', null);
      return Filing.getFiledOnBehalfOfName(filedOnBehalfOf);
    },
    isLocked () {
      return filingStore.isLocked;
    },
    hasFeeWaiver () {
      return this.feeWaiver !== null;
    },
    filingFeesTotal () {
      return this.leadDocketEntry.feeAmount;
    },
    filingFeesDue () {
      if (this.hasFeeWaiver)
      {
        return 0;
      }
      else
      {
        return this.filingFeesTotal;
      }
    }
  },
  methods: {
    loadData () {
      return this.loadFeeWaiver();
    },
    loadFeeWaiver () {
      let url = this.$cove.getAPI({
        name: 'api.filing',
        params: { id: filingStore.filingID },
        query: { fields: '**,feeWaiverReason(*)' }
      });

      return axios.get(url).
        then((response) => {
          this.feeWaiver = _.get(response, 'data.feeWaiverReason', null);
        });
    }
  }
};
</script>